module.exports = __webpack_public_path__ + "ee6539921d713482b8ccd4d0d23961bb.ttf";


//////////////////
// WEBPACK FOOTER
// ./scss/fonts/Montserrat/Montserrat-Regular.ttf
// module id = 1489
// module chunks = 142